import React, {Component} from 'react';
import {Collapse, Container, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import '../../styling/NavMenu.css';
import {AuthenticatedTemplate, MsalContext, UnauthenticatedTemplate} from '@azure/msal-react';
import {loginRequest} from '../../authConfig';
import {NavMenuConfig} from './NavMenuConfig';
import {SlMenu} from 'react-icons/sl';

export class NavMenu extends Component {

    static contextType = MsalContext;
    static displayName = NavMenu.name;
    static config = new NavMenuConfig();
    static menuConfigItem;

    constructor(props) {

        super(props);

        NavMenu.menuConfigItem = NavMenu.config.get(window.location.pathname);
        const mobileSectionCollapsed = {};
        for (let k in NavMenu.menuConfigItem.menus) {
            mobileSectionCollapsed[k] = true;
        }
        this.state = {
            collapsed: true,
            menuHover: false,
            activatedMenuItemIndex: -1,
            showMobileMenu: false,
            clientWidth: window.innerWidth,
            mobileSectionCollapsed: mobileSectionCollapsed
        };

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.menu_onMouseEnter = this.menu_onMouseEnter.bind(this);
        this.menu_onMouseLeave = this.menu_onMouseLeave.bind(this);
        this.menuItem_onMouseEnter = this.menuItem_onMouseEnter.bind(this);
        this.menuButton_onClick = this.menuButton_onClick.bind(this);
        this.closeMenu_onClick = this.closeMenu_onClick.bind(this);
        this.subMenuItem_onClick = this.subMenuItem_onClick.bind(this);
        this.menuItem_onClick = this.menuItem_onClick.bind(this);
        this.menuItem_onMobileClick = this.menuItem_onMobileClick.bind(this);

    }

    handleResize = e => {
        this.setState({clientWidth: e.target.innerWidth});
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize.bind(this));
    }

    handleLoginRedirect = () => {
        this.context.instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    handleLogout = () => {
        this.context.instance.logoutRedirect().catch((error) => console.log(error));
    };

    toggleNavbar() {
        this.setState({collapsed: !this.state.collapsed});
    }

    menu_onMouseEnter = () => {
        this.setState({menuHover: true});
    }

    menu_onMouseLeave = () => {
        this.setState({menuHover: false});
        this.setState({activatedMenuItemIndex: -1});
    }

    menuItem_onMouseEnter = (index) => {
        this.setState({activatedMenuItemIndex: index});
    }

    menuButton_onClick = () => {
        this.setState((current) => ({...current, showMobileMenu: true}));
    }

    closeMenu_onClick = () => {
        this.setState({showMobileMenu: false});
    }

    subMenuItem_onClick = (item) => {
        this.setState({showMobileMenu: false});
    }

    menuItem_onClick = (item) => {
        this.setState({showMobileMenu: false});
    }

    menuItem_onMobileClick = (section_text) => {
        let d = this.state.mobileSectionCollapsed;
        d[section_text] = !d[section_text];
        this.setState({mobileSectionCollapsed: d})
    }

    render() {
        let activatedMenuItemIndex = this.state.activatedMenuItemIndex
        let hasSubMenu = typeof (NavMenu.menuConfigItem.menus[0].sections) !== 'undefined'
        let nav_links = typeof (NavMenu.menuConfigItem.nav_links) !== 'undefined' ? NavMenu.menuConfigItem.nav_links : []
        let is_mobile = this.state.clientWidth < 768;
        let show_sub_section = false;
        if (is_mobile === true) {
            if (this.state.showMobileMenu === true) {
                show_sub_section = true;
            }
        } else {
            if (this.state.menuHover === true && activatedMenuItemIndex > -1 && hasSubMenu === true) {
                show_sub_section = true;
            }
        }

        return (
            <header>

                {/* the logo bar (top bar containing cubewraps logo) */}
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow  " container
                        light>
                    <NavbarBrand tag={Link} to="/">
                        <img src="/logo.svg" alt="CubeWraps" className="img-fluid" style={{height: '2rem'}}/>
                    </NavbarBrand>

                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2"/>
                    <Collapse className="d-sm-inline-flex " isOpen={!this.state.collapsed} navbar>
                        <Nav className="me-auto" navbar>
                            <NavItem>
                                <NavLink href="#" className='NavTitle'>{NavMenu.menuConfigItem.title}</NavLink>
                            </NavItem>
                        </Nav>
                        <ul className="navbar-nav flex-grow">
                            <AuthenticatedTemplate>

                                {nav_links.map(link => {
                                    return (
                                        <NavLink tag={Link} className="text-dark" to={link.path}>{link.text}</NavLink>)
                                })}

                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/" name="Home">Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <button className="btn btn-link text-dark text-decoration-none"
                                            onClick={this.handleLogout}>Sign out
                                    </button>
                                </NavItem>

                            </AuthenticatedTemplate>
                            <UnauthenticatedTemplate>

                                <NavItem>
                                    <button name='Log in' className="btn btn-link text-dark text-decoration-none"
                                            onClick={this.handleLoginRedirect}>Log in
                                    </button>
                                </NavItem>

                            </UnauthenticatedTemplate>
                        </ul>
                    </Collapse>
                </Navbar>

                {/* the navigation bar (secondary bar containing links to top-level pages) */}
                <AuthenticatedTemplate>
                    <Container>
                        <button data-testid="mobileBtnOpenMenu" className='mr-2 navbar-toggler btn-mobile'
                                onClick={this.menuButton_onClick.bind(this)}><SlMenu/></button>
                    </Container>

                    <div id="menu" data-testid="NavMenu" onMouseEnter={this.menu_onMouseEnter}
                         onMouseLeave={this.menu_onMouseLeave}>

                        {/* the navigation bar main site sections */}
                        <Container id="menu_sections">
                            <ul>
                                {NavMenu.menuConfigItem.menus.map((section, index) => {
                                    return (
                                        <li key={index} onMouseEnter={this.menuItem_onMouseEnter.bind(this, index)}
                                            className={[
                                                this.state.activatedMenuItemIndex === index && hasSubMenu === true ? 'menu_item_hover' : '',
                                                hasSubMenu === false && section.path === window.location.pathname ? 'menu_link_activated' : '',
                                                hasSubMenu === true ? 'menu_item' : 'menu_link'
                                            ].join(' ')}>
                                            {hasSubMenu === true ? (<> {section.text} <span> &raquo; </span> </>) :
                                                (<Link to={section.path}>  {section.text} <span>&gt;</span> </Link>)}
                                        </li>
                                    )
                                })}
                            </ul>
                        </Container>

                        {/* the navigation bar dropdown subsections */}
                        <div id="menu_sub_sections" className={[
                            show_sub_section === true ? '' : 'menu_hide',
                            this.state.showMobileMenu === true ? 'menu_sub_sections_mobile' : ''].join(' ')}>
                            <Container>
                                <button data-testid="mobileBtnCloseMenu" className='mr-2 navbar-toggler btn-mobile'
                                        onClick={this.closeMenu_onClick.bind(this)}><SlMenu/></button>
                                <ul>
                                    {NavMenu.menuConfigItem.menus.map((section, index) => {
                                        return (

                                            <li key={index} className={[
                                                this.state.activatedMenuItemIndex === index ? '' : 'menu_hide',
                                                is_mobile === false && hasSubMenu === false && section.path === window.location.pathname ? 'menu_link_activated' : '',

                                            ].join(' ')}>

                                                {hasSubMenu === true ? (
                                                    <div
                                                        className={[this.state.mobileSectionCollapsed[section.text] === true ? 'menu_activated_mobile' : ''].join(' ')}
                                                        onClick={this.menuItem_onMobileClick.bind(this, section.text)}>
                                                        <div>
                                                            {section.text} <span>&gt;</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <Link to={section.path}
                                                              onClick={this.menuItem_onClick.bind(this, section)}>
                                                            {section.text} <span>&gt;</span>
                                                        </Link>
                                                    </div>
                                                )}

                                                <ul id="ul_sub_sections" className={[
                                                    is_mobile === true ?
                                                        this.state.mobileSectionCollapsed[section.text] === true ? 'ul_sub_sections_activated' : ''
                                                        :
                                                        this.state.activatedMenuItemIndex === index ? 'ul_sub_sections_activated' : '',

                                                ].join(' ')}>
                                                    {typeof (section.sections) != 'undefined' && section.sections.map((item, index2) => {
                                                        return (
                                                            <li key={index2}>
                                                                <Link
                                                                    className='btn btn-link text-dark text-decoration-none'
                                                                    to={item.path}
                                                                    onClick={this.subMenuItem_onClick.bind(this, item)}>{item.text}</Link>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>

                                            </li>

                                        )
                                    })}
                                </ul>
                            </Container>
                        </div>

                    </div>
                </AuthenticatedTemplate>
            </header>

        );
    }
}
